// Start an issue or an improvement straight from a process map, for the whole process or one step. The map's catalog
// process is found (or the map joins the catalog), then the new issue or improvement opens with the process and step
// filled in. On a step, the open issues and improvements already at it.
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { imp } from "../improve/impApi";

type Kind = "issue" | "improve";

export function useStartFromMap() {
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const start = async (mapId: string, kind: Kind, step?: string) => {
    setBusy(true); setError(null);
    try {
      const p = await imp.forMap(mapId);
      const q = `process=${p.number}${step ? `&step=${encodeURIComponent(step)}` : ""}`;
      nav(kind === "issue" ? `/issues/new?${q}` : `/factory/new?${q}${p.area ? `&area=${p.area}` : ""}`);
    } catch (e) { setError(e instanceof Error ? e.message : String(e)); setBusy(false); }
  };
  return { start, busy, error };
}

/** On a selected step: what's open at it, and raise or improve here. */
export function StepStarts({ mapId, stepId }: { mapId: string; stepId: string }) {
  const { start, busy, error } = useStartFromMap();
  const [links, setLinks] = useState<Awaited<ReturnType<typeof imp.mapLinks>> | null>(null);
  useEffect(() => { let live = true; imp.mapLinks(mapId).then((x) => live && setLinks(x)).catch(() => live && setLinks(null)); return () => { live = false; }; }, [mapId]);
  const issues = links?.issues.filter((x) => x.step === stepId) ?? [];
  const reqs = links?.requests.filter((x) => x.step === stepId) ?? [];
  return (
    <div className="pmap-starts">
      <div className="pmap-starts-acts">
        <button className="btn pmap-sm" disabled={busy} onClick={() => start(mapId, "issue", stepId)}>Raise an issue here</button>
        <button className="btn pmap-sm" disabled={busy} onClick={() => start(mapId, "improve", stepId)}>Improve this step</button>
      </div>
      {error && <p className="pmap-note" role="alert">{error}</p>}
      {(issues.length > 0 || reqs.length > 0) && (
        <ul className="pmap-starts-list">
          {issues.map((x) => <li key={x.number}><Link to={`/r/${x.number}`}>{x.number}</Link> {x.title} <span className="muted">· {x.state.replace("_", " ")}</span></li>)}
          {reqs.map((x) => <li key={x.number}><Link to={`/factory/r/${x.number}`}>{x.number}</Link> {x.title} <span className="muted">· {x.stepLabel}</span></li>)}
        </ul>)}
    </div>
  );
}
